import CurrenciesActionTypes from './currencies-types'
import { getXCurrencies } from '../currencies/currencies-state'

const INITIAL_STATE = {
    currencies: null,
    loader: null,
    success: null,
    error: null,
}

const currenciesReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case CurrenciesActionTypes.START_GET_CURRENCIES_FROM_ASSETS:
            return {
                ...state,
                loader: { ...state.loader, GET_CURRENCIES_FROM_ASSETS: true },
            }
        case CurrenciesActionTypes.SUCCESS_GET_CURRENCIES_FROM_ASSETS:
            return {
                ...state,
                currencies: getXCurrencies(action.payload),
                loader: { ...state.loader, GET_CURRENCIES_FROM_ASSETS: null },
                success: { ...state.success, GET_CURRENCIES_FROM_ASSETS: true },
            }
        case CurrenciesActionTypes.FAILURE_GET_CURRENCIES_FROM_ASSETS:
            return {
                ...state,
                error: { ...state.error, GET_CURRENCIES_FROM_ASSETS: true },
                loader: { ...state.loader, GET_CURRENCIES_FROM_ASSETS: null },
                success: { ...state.success, GET_CURRENCIES_FROM_ASSETS: null },
            }
        case CurrenciesActionTypes.FINISH_GET_CURRENCIES_FROM_ASSETS:
            return {
                ...state,
                currencies: null,
                error: { ...state.error, GET_CURRENCIES_FROM_ASSETS: null },
                loader: { ...state.loader, GET_CURRENCIES_FROM_ASSETS: null },
                success: { ...state.success, GET_CURRENCIES_FROM_ASSETS: null },
            }
        case CurrenciesActionTypes.START_GET_CURRENCIES:
            return {
                ...state,
                loader: { ...state.loader, GET_CURRENCIES: true },
            }
        case CurrenciesActionTypes.SUCCESS_GET_CURRENCIES:
            return {
                ...state,
                currencies: action.payload,
                loader: { ...state.loader, GET_CURRENCIES: null },
                success: { ...state.success, GET_CURRENCIES: true },
            }
        case CurrenciesActionTypes.FAILURE_GET_CURRENCIES:
            return {
                ...state,
                error: { ...state.error, GET_CURRENCIES: true },
                loader: { ...state.loader, GET_CURRENCIES: null },
                success: { ...state.success, GET_CURRENCIES: null },
            }
        case CurrenciesActionTypes.FINISH_GET_CURRENCIES:
            return {
                ...state,
                currencies: null,
                error: { ...state.error, GET_CURRENCIES: null },
                loader: { ...state.loader, GET_CURRENCIES: null },
                success: { ...state.success, GET_CURRENCIES: null },
            }
        default:
            return state
    }
}

export default currenciesReducer
